import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Dashboard } from '../../pages/client/Dashboard';
import { DetailCardSkeleton } from '../shared/SkeletonLoaders';

/**
 * DashboardGate - Routes users to appropriate dashboard based on role
 * 
 * ASEGURADO -> stays on /dashboard (UserDashboard)
 * ADMIN/OPERADOR/SUPERVISOR -> redirects to /admin (AdminDashboard)
 */
export const DashboardGate = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      if (user.role === 'SUPERADMIN') {
        navigate('/superadmin', { replace: true });
        return;
      }
      if (user.role === 'TELEMARKETER') {
        navigate('/telemarketing', { replace: true });
        return;
      }
      const isAdmin = user.role === 'ADMIN' || 
                     user.role === 'OPERADOR' || 
                     user.role === 'SUPERVISOR';
      
      if (isAdmin) {
        navigate('/admin', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  // Show skeleton while loading or redirecting
  if (loading || !user) {
    return (
      <div className="p-6 max-w-7xl mx-auto space-y-6">
        <div className="space-y-2">
          <div className="h-9 bg-muted rounded w-64 animate-pulse" />
          <div className="h-5 bg-muted rounded w-96 animate-pulse" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[1, 2, 3, 4].map(i => <DetailCardSkeleton key={i} />)}
        </div>
      </div>
    );
  }

  const isAdmin = user.role === 'ADMIN' || 
                 user.role === 'OPERADOR' || 
                 user.role === 'SUPERVISOR' ||
                 user.role === 'SUPERADMIN';

  if (isAdmin) {
    return null;
  }

  // Render user dashboard for ASEGURADO
  return <Dashboard />;
};
